import { useDisableBodyScroll } from "@/src/hooks";
import clsx from "clsx";
import { useExpansionModalContext } from "./ExpansionModalContext";

const ExpansionModalContainer: React.FC<{
  children: React.ReactNode;
  classes?: {
    open?: string;
    closed?: string;
  };
}> = ({ children, classes }) => {
  const { isOpen } = useExpansionModalContext();
  useDisableBodyScroll(isOpen);

  return (
    <div
      className={clsx(
        "dark",
        isOpen
          ? clsx(
              // Faking a modal for seamless transition to fullscreen mode (and no re-renders)
              `z-modal fixed inset-0 flex h-full w-full flex-col flex-nowrap bg-gray-950 laptop:px-0`,
              classes?.open,
            )
          : clsx("relative", classes?.closed),
      )}
    >
      {children}
    </div>
  );
};

export default ExpansionModalContainer;
